import { Component } from '@angular/core';
import { App, MenuController, NavController, Events, LoadingController } from 'ionic-angular';
import { AccountLoginPage } from '../account-login/account-login';
import { AccountForgotPage } from '../account-forgot/account-forgot';

/**
 * SignUp Page
 * 
 * @export
 * @class AccountSignupPage
 */
@Component({
  selector: 'account-signup',
  templateUrl: 'account-signup.html'
})
export class AccountSignupPage {
  signFocus: boolean = false;
  constructor(
    public app: App,
    public nav: NavController,
    public menu: MenuController,
    public loading: LoadingController,
    public events: Events
  ) { }

  ionViewDidEnter() {
    this.app.setTitle('Signup');
  }

  onLogin() {
    this.nav.push(AccountLoginPage);
  }

  onForgot() {
    this.nav.push(AccountForgotPage);
  }
}


// WEBPACK FOOTER //
// ./src/pages/account-signup/account-signup.ts